/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The variant of the badge.
 */
export const BadgeComponentConfigVariant = {
  Default: "default",
  Tier2: "tier2",
  Tier3: "tier3",
  Brand: "brand",
  Critical: "critical",
  Good: "good",
  Warning: "warning",
  Caution: "caution",
  Cooling: "cooling",
  Eai: "eai",
} as const;
/**
 * The variant of the badge.
 */
export type BadgeComponentConfigVariant = OpenEnum<
  typeof BadgeComponentConfigVariant
>;

/**
 * The config of the badge component.
 */
export type BadgeComponentConfig = {
  /**
   * The label of the badge.
   */
  label: string;
  /**
   * The variant of the badge.
   */
  variant?: BadgeComponentConfigVariant | undefined;
};

/** @internal */
export const BadgeComponentConfigVariant$inboundSchema: z.ZodType<
  BadgeComponentConfigVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(BadgeComponentConfigVariant);
/** @internal */
export const BadgeComponentConfigVariant$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  BadgeComponentConfigVariant
> = openEnums.outboundSchema(BadgeComponentConfigVariant);

/** @internal */
export const BadgeComponentConfig$inboundSchema: z.ZodType<
  BadgeComponentConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  label: types.string(),
  variant: BadgeComponentConfigVariant$inboundSchema.default("default"),
});
/** @internal */
export type BadgeComponentConfig$Outbound = {
  label: string;
  variant: string;
};

/** @internal */
export const BadgeComponentConfig$outboundSchema: z.ZodType<
  BadgeComponentConfig$Outbound,
  z.ZodTypeDef,
  BadgeComponentConfig
> = z.object({
  label: z.string(),
  variant: BadgeComponentConfigVariant$outboundSchema.default("default"),
});

export function badgeComponentConfigToJSON(
  badgeComponentConfig: BadgeComponentConfig,
): string {
  return JSON.stringify(
    BadgeComponentConfig$outboundSchema.parse(badgeComponentConfig),
  );
}
export function badgeComponentConfigFromJSON(
  jsonString: string,
): SafeParseResult<BadgeComponentConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BadgeComponentConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BadgeComponentConfig' from JSON`,
  );
}
